import React, { useState } from "react";
import "./Checkout.css";
import ProductCard from "./ProductCard";
import arrow from "../../../assets/images/arrow.png";
import plus from "../../../assets/images/plus.png";
import OrderDetails from "./OrderDetails";
import AddressCard from "./AddressCard";
import Features from "./Features";
import { useHistory } from "../../../app-services/lib/router-compat";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

const ShippingDetails = () => {
  const history = useHistory();
  return (
    <div className="Checkout">
      <div className="checkout-container container">
        <div className="item-col">
          <div className="cart shipping-details-head">
            <div className="cart-count">Shipping Details</div>
            <button
              type="button"
              className="shipping-back-pill"
              onClick={() => history.push("/delivery")}
            >
              <span className="shipping-back-pill-icon">
                <ArrowBackRoundedIcon fontSize="inherit" />
              </span>
              Back to Delivery
            </button>
            {/* <div className="add-new"><img src={plus} className="img-plus"/>  ADD NEW BOOK</div> */}
          </div>
          <AddressCard />
        </div>
        <div className="bill-col">
          <OrderDetails />
        </div>
      </div>
      <div className="container">
        <Features />
      </div>
    </div>
  );
};
export default ShippingDetails;
